<template>
  <div class="page">
    <PageHeader :links="headLinks" />
    <div class="pageMain">
      <el-row style="margin-bottom: 20px">
        <el-col :sm="24" :md="12">
          <el-button size="small" type="primary" @click="exportToExcel" :disabled="tableData.length <= 0">导出成电子表格</el-button>
        </el-col>
        <el-col :sm="24" :md="12">
          <div style="display: flex; flex-direction: row">
            <div style="width: 90px; line-height: 32px">时间区域:</div>
            <div style="flex: 1">
              <el-date-picker style="width: 100%" type="daterange" :default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期" end-placeholder="结束日期" v-model="timeRange" format="yyyy年MM月dd日" value-format="yyyy-MM-dd H:m:s"></el-date-picker>
            </div>

            <div style="width: 80px; margin-left: 10px">
              <el-button type="primary" @click="loadData" style="width: 100%">检索</el-button>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-table ref="tableData" :data="tableData" stripe :default-expand-all="false" style="width: 100%">
        <el-table-column type="index" width="40" align="center"> </el-table-column>
        <el-table-column prop="userName" label="姓名"></el-table-column>
        <el-table-column prop="userCount" label="审稿数量"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import reportApi from "@/api/report"
import { outputExcel } from "@/utils/excelUtil"

export default {
  components: { PageHeader },
  data() {
    return {
      headLinks: [{ path: "", title: "专家审稿统计" }],
      timeRange: [],
      tableData: [],
    }
  },

  mounted() {
    //this.loadData();
  },

  methods: {
    loadData() {
      reportApi.getExportReport(this.timeRange, 1).then((res) => {
        this.tableData = res.data
      })
    },

    exportToExcel() {
      let sheetData = [
        ["专家审稿统计", "", ""],
        ["时间区域", this.timeRange[0], this.timeRange[1]],
        ["序号", "姓名", "数量"],
      ]

      let sData = JSON.parse(JSON.stringify(this.tableData))
      for (let i = 0; i < sData.length; i++) {
        let row = sData[i]
        let arr = [i + 1]
        for (let key in row) {
          if (key == "userName" || key == "userCount") {
            arr.push(row[key])
          }
        }
        sheetData.push(arr)
        //sheetData.push([i, row.userName, row.userCount]);
      }

      let sheetConfig = [
        {
          sheetName: "专家审稿统计",
          sheetData,
        },
      ]
      outputExcel(sheetConfig, "专家审稿统计")
    },
  },
}
</script>
